import { mapActions, mapGetters, mapMutations } from 'vuex';
import { email, required } from 'vuelidate/lib/validators';
import validation from '@/mixins/validation';

export default {
  name: 'Reset',
  data() {
    return {
      isShowEmailFlow: true,
      payload: {
        email: '',
        phone: ''
      },
      wrongEmail: [],
      validationErrors: {}
    };
  },
  mixins: [validation],
  validations() {
    let payload = this.isShowEmailFlow ? { email: { required, email } } : { phone: { required } };
    return { payload };
  },
  components: {},
  watch: {
    'payload.email': {
      immediate: true,
      handler(newVal, prevVal) {
        this.wrongEmail = [];
        if (newVal.length && newVal !== prevVal) {
          this.payload.email = newVal.trim();
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'auth/isLoading'
    }),
    emailErrors() {
      return this.computeErrors('payload', 'email', {
        required: 'validationRequired',
        email: 'validation.email'
      });
    },
    phoneErrors() {
      return this.computeErrors('payload', 'phone', {
        required: 'validationRequired'
      });
    }
  },
  created() {
    document.getElementById('html').classList.add('hide');
  },
  methods: {
    ...mapMutations({
      changeLoginPopup: 'popups/CHANGE_LOGIN_POPUP',
      modalClose: 'app/MODAL_CLOSE',
      modalOpen: 'app/MODAL_OPEN',
      modalSetData: 'app/MODAL_SET_DATA'
    }),
    ...mapActions({
      resetPasswordEmail: 'auth/RESET_PASSWORD_EMAIL',
      resetPasswordPhone: 'auth/RESET_PASSWORD_PHONE'
    }),
    sendPassword() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      if (this.isShowEmailFlow) {
        this.resetPasswordEmail({ email: this.payload.email })
          .then(() => {
            this.$toasted.success(this.$t('messageResetPassword'));
            this.modalClose('reset');
          })
          .catch((error) => {
            this.$toasted.error(error.data.message);
            console.log('error', error);
            this.wrongEmail.push(error.data.message);
          });
      } else {
        this.resetPasswordPhone({ phone: this.payload.phone })
          .then((res) => {
            console.log('res', { res });
            this.modalSetData({
              key: 'restore',
              data: { phone: this.payload.phone, type: 'phone' }
            });
            this.modalOpen('restore');
            this.modalClose('reset');
          })
          .catch((error) => {
            this.$toasted.error(error.data.message);
          });
      }
    }
  }
};
